import React, {Component} from 'react'
import ProblemStub from './ProblemStub'

class ListProblems extends Component {
  render() {
    let {problems, activeProblem} = this.props
    let sortedProblems = Object.assign([], problems).sort((a, b) => {
      let atime = a.timestamp || new Date('December 17, 1995 03:24:00')
      let btime = b.timestamp || new Date('December 17, 1995 03:24:00')
      return atime > btime ? -1 : 1
    })
    return (
      <div className="problem-list">
        {sortedProblems.map((problem, index) => {
          let selected = activeProblem && activeProblem.id === problem.id
          return (
            <ProblemStub
              key={problem.key}
              {...this.props}
              problem={problem}
              selected={selected}
            />
          )
        })}
      </div>
    )
  }
}

export default ListProblems



// WEBPACK FOOTER //
// ./src/components/problems/ListProblems.jsx